import { render, staticRenderFns } from "./Emblem.vue?vue&type=template&id=b7f06e78&scoped=true"
import script from "./Emblem.vue?vue&type=script&lang=js"
export * from "./Emblem.vue?vue&type=script&lang=js"
import style0 from "./Emblem.vue?vue&type=style&index=0&id=b7f06e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f06e78",
  null
  
)

export default component.exports